import { FileOpen, Search } from '@mui/icons-material';
import { Box, FormControl, Grid, InputLabel, LinearProgress, MenuItem, Paper, Select, TextField } from '@mui/material';
import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import TemplateParamsInput from '../../TemplateMessage/TemplateParamsInput';
import ucwords from 'ucwords';
import axios from 'axios';
import Api from '../../../customlib/Api';
import Global from '../../../customlib/Global';

class HsmSelector extends Component {
    state = { 
        listAppProfiles: [],
        isLoadingAppProfiles: false,
        appTypeId: "",
        selectedAppProfile: null,
        selectedHsmName: "",
        selectedHsm: null,

        listTemplates: [],
        listTemplatesDisplay: [],
        debounceTimeout: null,
        query: "",
        queryChangeApplied: true,
        paging: {},
        counter: 0,
        isLoading: false,
     } 

    handleAppTypeChanged = (event) => {
        const appProfiles = [...this.state.listAppProfiles];
        const selectedAppProfile = appProfiles.find(item => item._id === event.target.value);

        if(this.state.appTypeId !== event.target.value){
            this.setState({ selectedHsmName: "", selectedHsm: null, listTemplates: [], listTemplatesDisplay: [], query: "", queryChangeApplied: true });
        }

        this.setState({ appTypeId: event.target.value, selectedAppProfile: selectedAppProfile }, () => {
            console.log(this.state.appTypeId, this.state.selectedAppProfile);
            // this.getLavengerUsers();
        });
    }

    loadAppProfile = () => {
        this.setState({ isLoadingAppProfiles: true}, () => {
            const params = {};

            axios
                .post(
                    Api.listAppProfile(),
                    params,
                    Api.getRequestHeaderNoAuth()
                )
                .then((response) => {
                    console.log("App Profiles", response.data);

                    const profiles = response.data.data.filter((profile) => { return profile.enabled === true });

                    this.setState({ listAppProfiles: profiles, isLoadingAppProfiles: false });
                })
                .catch((error) => {
                    this.setState({ errorMessage: error.message, isLoadingAppProfiles: false });
                    console.error("There was an error!", error);
                    // this.props.onLogin();
                });
        });
        
    };

    handleSearchValueChange = (event) => {
        let query = event.target.value !== null && event.target.value !== undefined ? event.target.value : "";
        // console.log("QUERY : ", event.target.value);
        // const listTemplate = [...this.state.listTemplates];
        // let search = listTemplate.filter((template) => template.labelName.toLowerCase().includes(query.toLowerCase()));

        // if(search.length > 0){
        //     this.setState({listTemplates: listTemplate, listTemplatesDisplay: search});
        // }

        // const query = event.target.value;

        // Membatalkan timer sebelumnya (jika ada)
        let oldDebounceTimeout = this.state.debounceTimeout;
        clearTimeout(oldDebounceTimeout);

        // Menunda request untuk 500ms setelah pengguna berhenti mengetik
        let newDebounceTimeout = setTimeout(() => {
            // this.setState({}, () => {
            this.getHsmTemplate();
            // });
        }, 500); // 500ms jeda waktu

        this.setState({ query: query, queryChangeApplied: false, debounceTimeout: newDebounceTimeout });

    };

    handleHeaderValueChange = (event) => {

        const templateData = { ...this.state.selectedHsm };
        if (templateData.header) {
            templateData.header.type = templateData.structure.header.format;
            templateData.header.imageUrl = event.target.value;
            templateData.header.description = "";
        } else {
            templateData.header = {
                type: templateData.structure.header.format,
                headerUrl: event.target.value,
                description: ""
            };
        }


        this.setState({ selectedHsm: templateData });

    };

    onKeyDownHandler = (e) => {

        if (e.keyCode === 13) {
            this.getHsmTemplate();
            this.setState({ queryChangeApplied: true });
        }
    };

    handleHsmSelectionChanged = (event) => {
        const listHsm = [...this.state.listTemplates];
        const findSelectedHsm = listHsm.find(item => item.name === event.target.value);

        this.setState({ selectedHsmName: event.target.value, selectedHsm: findSelectedHsm });
    }

    getHsmTemplate = (url = null) => {

        this.setState(
            { isLoading: true },
            () => {
                var userData = Global.get();
                // const messageData = this.props.messageData();
                const params = {
                    userId: userData.user.id,
                    waBussinesNumber: this.state.selectedAppProfile?.waNumber,
                    appProfileId: this.state.appTypeId,
                    loadUrl: url,
                    query: this.state.query
                };

                console.log("API URL : ", Api.getWaMessageTemplates());
                console.log("PARAMS : ", params);
                console.log("HEADER : ", Api.getRequestHeader());

                axios
                    .post(Api.getWaMessageTemplates(), params, Api.getRequestHeader())
                    .then((response) => {

                        console.log("MyCustomerToday : ", response.data.data.templates);
                        var responseData = response.data.data;
                        var templates = responseData.templates;
                        var paging = responseData.paging;

                        templates = templates.filter(item => item.status === "APPROVED");

                        templates.forEach(element => {
                            element.labelName = ucwords(element.name.replaceAll("_", " "));
                            let count = (element.structure.body.match(/{{/g) || []).length;
                            var params = [];
                            for (var i = 0; i < count; i++) {
                                params.push({ paramValue: "", paramIndex: i, paramLabel: i + 1 });
                            }
                            element.params = params;
                        });

                        console.log("TEMPLATES : ", templates);

                        this.setState({ listTemplates: templates, paging: paging, counter: responseData.counter, listTemplatesDisplay: templates, isLoading: false }, () => { console.log(this.state.listTemplates) });
                        // this.setState({listSales: response.data.data});
                    })
                    .catch((error) => {
                        this.setState({ isLoading: false });
                        console.error("There was an error!", userData.user.id, error);
                    });
            }
        );

    };

    handleUpdateParamValue = (templateId, paramIndex, paramValue) => {
        console.log(templateId, paramIndex, paramValue);

        const clonedTemplates = [...this.state.listTemplates];
        let template = clonedTemplates.filter((template) => template.id === templateId);

        if (template.length > 0) {
            template[0].params[paramIndex].paramValue = paramValue;
        }

        console.log("FOUNDTEMPLATE", template);

        this.setState({ listTemplates: clonedTemplates, selectedHsm: template[0] }, () => { 
            console.log("UPDATEDTEMPLATES : ", this.state.listTemplates); 
            this.props.onUpdate(template[0]);
        });

    }

    handleUpdateHeaderValue = (templateId, paramValue) => {
        console.log(templateId, paramValue);

        const clonedTemplates = [...this.state.listTemplates];
        let template = clonedTemplates.filter((template) => template.id === templateId);

        if (template.length > 0) {
            template[0].headerUrl = paramValue;
            template[0].hasHeader = true;
        }

        console.log("FOUNDTEMPLATE", template);

        this.setState({ listTemplates: clonedTemplates, selectedHsm: template[0] }, () => { 
            console.log("UPDATEDTEMPLATES : ", this.state.listTemplates); 
            this.props.onUpdate(template[0]);
        });

    }



    componentDidMount() { 
        this.loadAppProfile();
        this.setState({ selectedHsm: this.props.selectedHsm }); ;
     }

    render() { 
        return (
            <Box>
                <Paper elevation={0} sx={{ p: "10px", mr: "5px" }}>
                    <h5>HSM Setup</h5>
                    <Box sx={{ mt: "10px" }}>
                        <FormControl variant="outlined" style={{ width: '100%' }} size="small">
                            <InputLabel id="demo-simple-select-outlined-label">Pilih Aplikasi</InputLabel>
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={this.state.appTypeId}
                                onChange={this.handleAppTypeChanged}
                                label="Aplikasi"
                            >
                                {
                                    this.state.listAppProfiles.map(
                                        (profile) => {
                                            return (<MenuItem key={profile._id} value={profile._id}>{profile.label}</MenuItem>);
                                        }
                                    )
                                }
                            </Select>
                        </FormControl>
                        {
                            this.state.isLoadingAppProfiles && <LinearProgress />
                        }
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <TextField
                                    onKeyDown={this.onKeyDownHandler}
                                    onChange={this.handleSearchValueChange}
                                    label="Cari nama HSM"
                                    type="text"
                                    className="form-control"
                                    variant="outlined"
                                    size='small'
                                    value={this.state.query}
                                    disabled={this.state.selectedAppProfile === null}
                                    sx={{ mt: "10px" }}
                                />
                                {
                                    this.state.isLoading && <LinearProgress />
                                }

                                {
                                    this.state.queryChangeApplied === false && (
                                        <Box sx={{ fontSize: "10px", marginTop: "5px", color: "red" }}>Tekan <strong>ENTER</strong> atau <Search sx={{ width: "15px" }} /> untuk apply pencarian</Box>
                                    )
                                }

                            </Grid>
                            {/* <Grid item xs={1}>
                                <Tooltip title={"Cari nama HSM"}>
                                    <IconButton color='primary' disabled={this.state.isRekomendasiMode} onClick={() => this.getHsmTemplate()}><Search /></IconButton>
                                </Tooltip>
                            </Grid> */}
                            {/* <Grid item xs={1}>
                                <Tooltip title={"Reload HSM"}>
                                    <IconButton color='warning' onClick={() => this.getHsmTemplate()}><Refresh /></IconButton>
                                </Tooltip>
                            </Grid> */}
                            <Grid item xs={12}>
                                <FormControl variant="outlined" sx={{ width: '100%', mt: "10px" }} size="small">
                                    <InputLabel id="cb-hsm">Pilih HSM</InputLabel>
                                    <Select
                                        labelId="cb-hsm"
                                        id="cb-hsm"
                                        value={this.state.selectedHsmName}
                                        onChange={this.handleHsmSelectionChanged}
                                        label="HSM"
                                        disabled={this.state.listTemplates.length <= 0}
                                    >
                                        {
                                            this.state.listTemplates?.map(
                                                (hsm) => {
                                                    return (<MenuItem key={hsm.id} value={hsm.name}>{hsm.labelName}</MenuItem>);
                                                }
                                            )
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                {
                                    this.state.selectedHsm && (
                                        <div className="container border border-warning rounded" style={{ marginBottom: 5 }}>
                                            <Box>
                                                {/* <h5>
                                                {ucwords(this.state.selectedHsm.name.replaceAll("_", " "))}
                                            </h5> */}
                                                <span className={this.state.selectedHsm.category === "MARKETING" ? "badge badge-danger" : "badge badge-success"}><small>{ucwords(this.state.selectedHsm.category.replaceAll("_", " ").toLowerCase())}</small></span>
                                            </Box>
                                            {/* <div className="row">
                                            <div className="col-9">
                                                <h5>
                                                    {ucwords(this.state.selectedHsm.name.replaceAll("_", " "))}
                                                </h5>
                                                <span className={this.state.selectedHsm.category === "MARKETING" ? "badge badge-danger" : "badge badge-success"}><small>{ucwords(this.state.selectedHsm.category.replaceAll("_", " ").toLowerCase())}</small></span>
                                            </div>
                                            <div className="col-2 text-right">
                                                button
                                                {
                                                    this.state.isSending && this.state.sendingTemplateId===template.id ? 
                                                    (
                                                        // <></>
                                                        <ReactLoading color="#FF0000" type="bubbles" width={50} height={10}/>
                                                    ) : 
                                                    (
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            size="small"
                                                            onClick={() => {this.handleSendTemplate(template)}}
                                                            // className={classes.button}
                                                            endIcon={ <Send />}
                                                            disabled={template.hsmEnabled === false}
                                                        >
                                                            Kirim
                                                        </Button>
                                                    )
                                                }
                                                
                                                
                                            </div>
                                        </div> */}
                                            <hr />
                                            {
                                                !this.state.selectedHsm.isAllInputvalid && <Box>{this.state.selectedHsm.errMessage}</Box>
                                            }
                                            {this.state.selectedHsm.structure.body}
                                            {
                                                this.state.selectedHsm.structure.header !== undefined && this.state.selectedHsm.structure.header.format === "IMAGE" ?
                                                    (
                                                        <div className="container-fluid">
                                                            <hr />
                                                            {/* {
                                                            this.state.selectedHsm.hsmEnabled === false ? (<div className="btn btn-secondary btn-block disabled">
                                                            Pilih Gambar
                                                        </div>) : (<div className="btn btn-primary btn-block" onClick={(event) => this.handleOpenListHsmImage(event, this.state.selectedHsm)}>
                                                            Pilih Gambar
                                                        </div>)
                                                        } */}
                                                            <br />
                                                            <div className="container-fluid text-center">
                                                                {
                                                                    this.state.selectedHsm.header === undefined ? "Gambar belum dipilih" :
                                                                        (
                                                                            <div className='text-center'>
                                                                                <img src={this.state.selectedHsm.header.imageUrl} style={{ maxWidth: "100%", maxHeight: "200px" }} />
                                                                                <br />
                                                                                {this.state.selectedHsm.header.description}
                                                                            </div>
                                                                        )
                                                                }
                                                            </div>
                                                        </div>
                                                    ) :
                                                    this.state.selectedHsm.structure.header !== undefined && this.state.selectedHsm.structure.header.format === "VIDEO" ?
                                                        (
                                                            <div className="container-fluid">
                                                                <hr />
                                                                {/* {
                                                            this.state.selectedHsm.hsmEnabled === false ? (<div className="btn btn-secondary btn-block disabled">
                                                            Pilih Video
                                                        </div>) : (<div className="btn btn-primary btn-block" onClick={(event) => this.handleOpenListHsmImage(event, this.state.selectedHsm)}>
                                                            Pilih Video
                                                        </div>)
                                                        } */}
                                                                <br />
                                                                <div className="container-fluid text-center">
                                                                    {
                                                                        this.state.selectedHsm.header === undefined ? "Video belum dipilih" :
                                                                            (
                                                                                <div className='text-center'>
                                                                                    {/* <img src={template.header.imageUrl} style={{maxWidth: "100%", maxHeight: "200px"}} /> */}
                                                                                    {/* <img src={"https://lotus.prestisa.id/lavenger-backend/public/videos/08a12b53600665f78cc1071510327b62.mp4"} style={{maxWidth: "100%", maxHeight: "200px"}} /> */}
                                                                                    {/* <ReactPlayer width="100%" style={{maxHeight: "250px"}} controls={true} url={data.message.fileName !== undefined && data.message.fileName.startsWith("http") ? data.message.fileName : Api.getBaseVideosUrl() + data.message.fileName} /> */}
                                                                                    <ReactPlayer width="100%" style={{ maxHeight: "250px" }} controls={true} url={this.state.selectedHsm.header.imageUrl} />
                                                                                    <br />
                                                                                    {this.state.selectedHsm.header.description}
                                                                                </div>
                                                                            )
                                                                    }
                                                                </div>

                                                            </div>
                                                        ) :
                                                        this.state.selectedHsm.structure.header !== undefined && this.state.selectedHsm.structure.header.format === "DOCUMENT" ?
                                                            (
                                                                <div className="container-fluid">
                                                                    <hr />
                                                                    {/* {
                                                            this.state.selectedHsm.hsmEnabled === false ? (<div className="btn btn-secondary btn-block disabled">
                                                            Pilih Dokumen
                                                        </div>) : (<div className="btn btn-primary btn-block" onClick={(event) => this.handleOpenListHsmImage(event, this.state.selectedHsm)}>
                                                            Pilih Dokumen
                                                        </div>)
                                                        } */}

                                                                    <br />
                                                                    <div className="container-fluid text-center">
                                                                        {
                                                                            this.state.selectedHsm.header === undefined ? "Dokumen URL Belum Ditentukan" :
                                                                                (
                                                                                    <div className='text-center'>
                                                                                        <FileOpen />
                                                                                        {/* <img src={template.header.imageUrl} style={{maxWidth: "100%", maxHeight: "200px"}} /> */}
                                                                                        {/* <img src={"https://lotus.prestisa.id/lavenger-backend/public/videos/08a12b53600665f78cc1071510327b62.mp4"} style={{maxWidth: "100%", maxHeight: "200px"}} /> */}
                                                                                        {/* <ReactPlayer width="100%" style={{maxHeight: "250px"}} controls={true} url={data.message.fileName !== undefined && data.message.fileName.startsWith("http") ? data.message.fileName : Api.getBaseVideosUrl() + data.message.fileName} /> */}
                                                                                        {/* <ReactPlayer width="100%" style={{maxHeight: "250px"}} controls={true} url={template.header.imageUrl} /> */}
                                                                                        <br />
                                                                                        {this.state.selectedHsm.header.description}
                                                                                    </div>
                                                                                )
                                                                        }
                                                                    </div>

                                                                </div>
                                                            ) :
                                                            (<></>)
                                            }
                                            {
                                                this.state.selectedHsm.structure.header !== undefined && (
                                                    <TextField
                                                        onChange={(event) => this.handleUpdateHeaderValue(this.state.selectedHsm.id, event.target.value)}
                                                        label={`${this.state.selectedHsm.structure.header.format} URL`}
                                                        type="text"
                                                        className="form-control"
                                                        variant="outlined"
                                                        size='small'
                                                        value={this.state.selectedHsm.headerUrl !== undefined ? this.state.selectedHsm.headerUrl : ""}
                                                        sx={{ mt: "10px" }}
                                                    />
                                                )
                                            }

                                            <hr />
                                            {
                                                this.state.selectedHsm.params.map(
                                                    (param) => {
                                                        return (
                                                            <TemplateParamsInput
                                                                templateData={this.state.selectedHsm}
                                                                paramData={param}
                                                                onUpdateData={this.handleUpdateParamValue}
                                                                disabled={this.state.selectedHsm.hsmEnabled === false}
                                                            />);
                                                    }
                                                )
                                            }


                                        </div>
                                    )
                                }
                            </Grid>
                        </Grid>

                    </Box>
                </Paper>
            </Box>
        );
    }
}
 
export default HsmSelector;